import { useCurrentUser } from '@/utils/hooks/useUser'
import { useMatchRoute } from '@tanstack/react-router'
import { Tab } from './config'

export function useActiveTab() {
	const user = useCurrentUser()
	const matchRoute = useMatchRoute()

	if (matchRoute({ to: '/following' })) {
		return Tab.FOLLOWING_POST
	}
	if (
		matchRoute({
			to: '/explore',
		})
	) {
		return Tab.EXPLORE_POST
	}

	if (
		matchRoute({
			to: '/notification',
		})
	) {
		return Tab.NOTIFICATION
	}

	if (
		matchRoute({
			to: '/u/$username',
			params: {
				username: user.username,
			},
		})
	) {
		return Tab.USER_PROFILE
	}

	if (
		matchRoute({
			to: '/more',
		})
	) {
		return Tab.MORE
	}

	return null
}
